'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactHelmet = require('react-helmet');var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
var _reactScroll = require('react-scroll');
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _ = require('../');
var _HE = require('../../../static/badge/android/HE.png');var _HE2 = _interopRequireDefault(_HE);
var _HE3 = require('../../../static/badge/ios/HE.svg');var _HE4 = _interopRequireDefault(_HE3);
var _constants = require('../../constants');

var _MobilePromotion = require('./MobilePromotion.scss');var styles = _interopRequireWildcard(_MobilePromotion);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}

// The reason why not use assets url from constant because images located on prod cloud name
var assetsBaseUrl = 'https://res.cloudinary.com/onmap-prod/image/upload';
var onMapLogo = function onMapLogo() {return _react2.default.createElement('img', { width: '126px', height: '28px', src: _constants.onMapLogoWhite, alt: '' });};
var imageMapper = {
  main: {
    desktop: 'Main_Image',
    mobile: 'mobile_main_image' },

  search: {
    ios: 'iPhone_1',
    android: 'Android_2' },

  filter: {
    ios: 'iPhone_3',
    android: 'Android_1' },

  customization: {
    ios: 'iPhone_2',
    android: 'Android_3' } };var



MobilePromotion = function (_Component) {_inherits(MobilePromotion, _Component);function MobilePromotion() {var _temp, _this, _ret;_classCallCheck(this, MobilePromotion);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.





























    mainSectionHeight = __CLIENT__ ? window.innerHeight - 55 + 'px' : 'auto', _this.
    tabSectionHeight = __CLIENT__ ? window.innerHeight - (_this.props.isMobile ? 47 : 0) + 'px' : 'auto', _this.
    images = Object.create(null), _this.

    imageUrlBuilder = function (section, type) {var version = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '1503926336';
      var options = '/c_fill,f_auto';
      var imageName = imageMapper[section][type];

      if (__CLIENT__) {
        var _height = type === 'ios' || type === 'android' ?
        Math.floor(window.innerHeight * 0.8) :
        window.innerHeight - 55;
        options = options + ',h_' + _height;
      }

      return '' + assetsBaseUrl + options + '/v' + version + '/promotion_mobile/' + imageName;
    }, _this.

    renderTabRow = function (sectionName, icon, iconFirst, platform) {var _cx;var
      isMobile = _this.props.isMobile;
      var section = sectionName + 'Section';
      var title = _this.props.translate('mobilePromotion', section, 'title')();
      var description = _this.props.translate('mobilePromotion', section, 'description');

      if (platform) {
        description = description(platform);
      }

      description = description();

      return (
        _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.tabRow, (_cx = {}, _cx[styles.reverse] = !iconFirst && !isMobile, _cx)) },
          !isMobile &&
          _react2.default.createElement('div', { className: styles.iconContainer },
            _react2.default.createElement('i', { className: 'icon icon-' + icon },
              _react2.default.createElement('span', { className: 'path1' }),
              _react2.default.createElement('span', { className: 'path2' }),
              _react2.default.createElement('span', { className: 'path3' }))),




          _react2.default.createElement('div', null,
            _react2.default.createElement('p', { className: styles.tabTitle },
              isMobile &&
              _react2.default.createElement('i', { className: 'icon icon-' + icon },
                _react2.default.createElement('span', { className: 'path1' }),
                _react2.default.createElement('span', { className: 'path2' }),
                _react2.default.createElement('span', { className: 'path3' })),



              _react2.default.createElement('span', null, title)),


            _react2.default.createElement('p', { className: styles.tabDescription }, description))));



    }, _temp), _possibleConstructorReturn(_this, _ret);}MobilePromotion.prototype.componentWillMount = function componentWillMount() {this.images = { main: { desktop: this.imageUrlBuilder('main', 'desktop'), mobile: this.imageUrlBuilder('main', 'mobile', '1507040308') }, search: { ios: this.imageUrlBuilder('search', 'ios'), android: this.imageUrlBuilder('search', 'android') }, filter: { ios: this.imageUrlBuilder('filter', 'ios'), android: this.imageUrlBuilder('filter', 'android') }, customization: { ios: this.imageUrlBuilder('customization', 'ios'), android: this.imageUrlBuilder('customization', 'android') } };};MobilePromotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {var height = _ref.windowDimentions,isMobile = _ref.isMobile;var prevHeight = this.props.windowDimentions.height;if (height !== prevHeight) {this.mainSectionHeight = window.innerHeight - 55 + 'px';this.tabSectionHeight = window.innerHeight - (isMobile ? 47 : 0) + 'px';}};MobilePromotion.prototype.

  render = function render() {
    var translate = this.props.translate('mobilePromotion');
    var mainImage = this.props.isMobile ?
    this.images.main.mobile :
    this.images.main.desktop;
    var mainImagePosition = this.props.isMobile ?
    'bottom' :
    'right';
    var mainSectionStyle = {
      height: this.mainSectionHeight,
      background: 'url(\'' + mainImage + '\') ' + mainImagePosition,
      backgroundSize: 'cover' };


    return (
      _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.mobilePromotion, 'rtl') },
        _react2.default.createElement(_reactHelmet2.default, {
          titleTemplate: this.props.translate('title', 'titleTemplate')(),
          title: this.props.translate('title', 'mobilePromotion')(),
          meta: [{ property: 'og:title', content: 'OnMap | ' + this.props.translate('title', 'mobilePromotion') }] }),


        _react2.default.createElement(_reactScroll.Element, { name: 'main-section' },
          _react2.default.createElement('div', { className: styles.mainSection, style: mainSectionStyle },
            _react2.default.createElement('div', { className: styles.promotionDescription },
              _react2.default.createElement('div', { className: styles.logo },
                _react2.default.createElement('img', { width: '220px', height: '55px', src: _constants.onMapLogoBlue, alt: '' })),


              _react2.default.createElement('h1', { className: styles.mobilePromotionTitle },
                translate('mainSection', 'titleP1'),

                !this.props.isMobile && _react2.default.createElement('br', null),
                this.props.isMobile && ' ',

                translate('mainSection', 'titleP2')),


              _react2.default.createElement('h2', { className: styles.mobilePromotionDescription },
                translate('mainSection', 'description'), ' ', _react2.default.createElement('span', { className: styles.logoText }, 'OnMap')),


              _react2.default.createElement('div', { className: styles.appLinksSection },
                _react2.default.createElement('a', { href: _constants.playmarketLink, target: '_blank', rel: 'nofollow noopener noreferrer' },
                  _react2.default.createElement('img', { src: _HE2.default, alt: 'android-badge', className: styles.appBadge }),
                  _react2.default.createElement('br', null), 'Android'),



                _react2.default.createElement('a', { href: _constants.appStoreLink, target: '_blank', rel: 'nofollow noopener noreferrer' },
                  _react2.default.createElement('img', { src: _HE4.default, alt: 'iOS-badge', className: styles.appBadge }),
                  _react2.default.createElement('br', null), 'iPhone'))))),







        _react2.default.createElement(_.OMTabs, { className: styles.promotionTabs, defaultActiveTabKey: 'appstore' },
          !this.props.isMobile &&
          _react2.default.createElement(_.OMTab, { id: 'onmap-label', title: onMapLogo, headerClassName: styles.tabHeaderLabel }),


          _react2.default.createElement(_.OMTab, { id: 'appstore', title: 'iPhone' },
            _react2.default.createElement('div', { style: { height: this.tabSectionHeight }, className: (0, _classnames2.default)(styles.tab, styles.searchTab) },
              this.renderTabRow('search', 'search-v2', true),

              _react2.default.createElement('img', {
                src: this.images.search.ios,
                className: styles.device,
                alt: '' })),



            _react2.default.createElement('div', { style: { height: this.tabSectionHeight }, className: (0, _classnames2.default)(styles.tab, styles.filterTab) },
              this.renderTabRow('filter', 'target', false),

              _react2.default.createElement('img', {
                src: this.images.filter.ios,
                className: (0, _classnames2.default)(styles.device, styles.fromRight),
                alt: '' })),



            _react2.default.createElement('div', { style: { height: this.tabSectionHeight }, className: (0, _classnames2.default)(styles.tab, styles.customizationTab) },
              this.renderTabRow('customization', 'ux', true, 'ios'),

              _react2.default.createElement('img', {
                src: this.images.customization.ios,
                className: styles.device,
                alt: '' }))),




          _react2.default.createElement(_.OMTab, { id: 'playmarket', title: 'Android' },
            _react2.default.createElement('div', { style: { height: this.tabSectionHeight }, className: (0, _classnames2.default)(styles.tab, styles.searchTab) },
              this.renderTabRow('search', 'search-v2', true),

              _react2.default.createElement('img', {
                src: this.images.search.android,
                className: styles.device,
                alt: '' })),



            _react2.default.createElement('div', { style: { height: this.tabSectionHeight }, className: (0, _classnames2.default)(styles.tab, styles.filterTab) },
              this.renderTabRow('filter', 'target', false),

              _react2.default.createElement('img', {
                src: this.images.filter.android,
                className: (0, _classnames2.default)(styles.device, styles.fromRight),
                alt: '' })),



            _react2.default.createElement('div', { style: { height: this.tabSectionHeight }, className: (0, _classnames2.default)(styles.tab, styles.customizationTab) },
              this.renderTabRow('customization', 'ux', true, 'android'),

              _react2.default.createElement('img', {
                src: this.images.customization.android,
                className: (0, _classnames2.default)(styles.device),
                alt: '' }))))));






  };return MobilePromotion;}(_react.Component);exports.default = MobilePromotion;


MobilePromotion.propTypes = {
  translate: _propTypes2.default.func,
  windowDimentions: _propTypes2.default.object,
  isMobile: _propTypes2.default.bool };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/MobilePromotion/MobilePromotion.js
// module id = 2688
// module chunks = 0